export default __webpack_public_path__ + "static/map/img/districts.5acca2a.svg";